<template>
  <div class="container">
    <b-row>
      <div class="col-sm-6">
        <div class="ld-card-header">
          <img src="@/assets/images/logos/logoMarioViajes.png" alt="" width="55%">
        </div>
      </div>
      <div class="col-sm-6">
        <div class="float-right">
          <button class="btn btn-warning btn-sm " @click="$emit('closeModal')" v-b-tooltip.hover :title="$gettext('Close')">
            <b-icon icon="x" />
          </button>
        </div>
      </div>
      <b-col><hr></b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'modalHeader'
}
</script>
